import { Button } from "@material-ui/core";
import IncidentLinkButton from "../Components/IncidentLinkButton";
import { withStyles } from "@material-ui/core/styles";
import { formatNameFromPersonObj, personAlertColor } from "./utils";
import moment from "moment";

const StyledTableLinkButton = withStyles(() => ({
  root: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline",
    margin: "0",
    padding: "0",
    textTransform: "none",
  },
}))(Button);

//The idNames need to match the row names in the parse function
export const homeAddressHeaders = [
  { title: "Name", idName: "name", show: true },
  { title: "Home Address", idName: "address", show: true },
  { title: "DOB", idName: "dob", show: true },
  { title: "Phone", idName: "phone", show: true },
  { title: "History/Associates", idName: "history", show: true },
  { title: "Add", idName: "addButton", show: true },
];

export function parseHomeAddressPerson(
  arr,
  historyClickHandler,
  incidentId,
  handleAddPerson,
  handleOpenPerson
) {
  if (!arr || !Array.isArray(arr)) {
    console.error("Invalid input: arr should be an array");
    return null;
  }
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((person) => {
      const { personalAttribute, id: personId } = person || {};
      const { dob, phone } = personalAttribute || "";
      const { homeAddress } = personalAttribute || {};
      const name = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(person) }}
          data-cy={"tablecell-person-name-link-" + person?.id}
          onClick={() => {
            handleOpenPerson(person?.id, true);
          }}
        >
          {formatNameFromPersonObj(person)}
        </StyledTableLinkButton>
      );
      const dobString =
        moment
          .utc(dob, "YYYY-MM-DD HH:mm:ss UTC")
          .local()
          .format("MM/DD/YYYY") || "";
      const addressString = homeAddress?.name || "";

      const historyButton = (
        <button
          style={{
            backgroundColor: "transparent",
            color: "#6096d1",
            fontWeight: "bold",
            fontSize: "1rem",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
            display: "inline",
            margin: "0",
            padding: "0",
            "&:hover": {
              textDecoration: "none",
            },
            "&:focus": {
              textDecoration: "none",
            },
          }}
          onClick={() => {
            historyClickHandler(person);
          }}
        >
          Show History
        </button>
      );
      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-add-person-to-incident" + person?.id}
          onClick={() => handleAddPerson(person, incidentId)}
        >
          Add
        </button>
      ) : null;

      tempRows.push(
        createHomeAddressData(
          name,
          addressString,
          dobString,
          phone,
          historyButton,
          addButton,
          personId
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createHomeAddressData(
  name,
  address,
  dob,
  phone,
  history,
  addButton,
  personId
) {
  return { name, address, dob, phone, history, addButton, personId };
}

// ********************************************************************************************** //
export const mailingAddressHeaders = [
  { title: "Name", idName: "name", show: true },
  { title: "Mailing Address", idName: "address", show: true },
  { title: "DOB", idName: "dob", show: true },
  { title: "Phone", idName: "phone", show: true },
  { title: "History/Associates", idName: "history", show: true },
  { title: "Add", idName: "addButton", show: true },
];

export function parseMailingAddressPerson(
  arr,
  historyClickHandler,
  incidentId,
  handleAddPerson,
  handleOpenPerson
) {
  if (!arr || !Array.isArray(arr)) {
    console.error("Invalid input: arr should be an array");
    return null;
  }
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((person) => {
      const { personalAttribute, id: personId } = person || {};
      const { dob, phone } = personalAttribute || "";
      const { mailingAddress } = personalAttribute || {};
      const name = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(person) }}
          data-cy={"tablecell-person-name-link-" + person?.id}
          onClick={() => {
            handleOpenPerson(person?.id, true);
          }}
        >
          {formatNameFromPersonObj(person)}
        </StyledTableLinkButton>
      );
      const dobString =
        moment
          .utc(dob, "YYYY-MM-DD HH:mm:ss UTC")
          .local()
          .format("MM/DD/YYYY") || "";
      const addressString = mailingAddress?.name || "";

      const historyButton = (
        <button
          style={{
            backgroundColor: "transparent",
            color: "#6096d1",
            fontWeight: "bold",
            fontSize: "1rem",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
            display: "inline",
            margin: "0",
            padding: "0",
            "&:hover": {
              textDecoration: "none",
            },
            "&:focus": {
              textDecoration: "none",
            },
          }}
          onClick={() => {
            historyClickHandler(person);
          }}
        >
          Show History
        </button>
      );

      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-add-person-to-incident" + person?.id}
          onClick={() => handleAddPerson(person, incidentId)}
        >
          Add
        </button>
      ) : null;

      tempRows.push(
        createMailingAddressData(
          name,
          addressString,
          dobString,
          phone,
          historyButton,
          addButton,
          personId
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createMailingAddressData(
  name,
  address,
  dob,
  phone,
  history,
  addButton,
  personId
) {
  return { name, address, dob, phone, history, addButton, personId };
}

// ********************************************************************************************** //
export const addressPersonHistoryHeaders = [
  { title: "Name", idName: "name", show: true },
  { title: "Home Address", idName: "address", show: true },
  { title: "DOB", idName: "dob", show: true },
  { title: "Phone", idName: "phone", show: true },
  { title: "History/Associates", idName: "history", show: true },
  { title: "Add", idName: "addButton", show: true },
];

export function parseAddressPersonHistory(
  arr,
  historyClickHandler,
  incidentId,
  handleAddPerson,
  handleOpenPerson
) {
  if (!arr || !Array.isArray(arr)) {
    console.error("Invalid input: arr should be an array");
    return null;
  }
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((person) => {
      const { personalAttribute, id: personId } = person || {};
      const { dob, phone } = personalAttribute || "";
      const { homeAddress } = personalAttribute || {};
      const name = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(person) }}
          data-cy={"tablecell-person-name-link-" + person?.id}
          onClick={() => {
            handleOpenPerson(person?.id, true);
          }}
        >
          {formatNameFromPersonObj(person)}
        </StyledTableLinkButton>
      );

      const dobString =
        moment
          .utc(dob, "YYYY-MM-DD HH:mm:ss UTC")
          .local()
          .format("MM/DD/YYYY") || "";
      const addressString = homeAddress?.name || "";

      const historyButton = (
        <button
          style={{
            backgroundColor: "transparent",
            color: "#6096d1",
            fontWeight: "bold",
            fontSize: "1rem",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
            display: "inline",
            margin: "0",
            padding: "0",
            "&:hover": {
              textDecoration: "none",
            },
            "&:focus": {
              textDecoration: "none",
            },
          }}
          onClick={() => {
            historyClickHandler(person);
          }}
        >
          Show History
        </button>
      );

      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-add-person-to-incident" + person?.id}
          onClick={() => handleAddPerson(person, incidentId)}
        >
          Add
        </button>
      ) : null;

      tempRows.push(
        createAddressPersonHistoryData(
          name,
          addressString,
          dobString,
          phone,
          historyButton,
          addButton,
          personId
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createAddressPersonHistoryData(
  name,
  address,
  dob,
  phone,
  history,
  addButton,
  personId
) {
  return { name, address, dob, phone, history, addButton, personId };
}

// ********************************************************************************************** //

export const addressIncidentPeopleHeaders = [
  { title: "Incident Number", idName: "incidentNumber", show: true },
  { title: "Name", idName: "name", show: true },
  { title: "Home Address", idName: "address", show: true },
  { title: "DOB", idName: "dob", show: true },
  { title: "Phone", idName: "phone", show: true },
  { title: "History/Associates", idName: "history", show: true },
  { title: "Add", idName: "addButton", show: true },
];

export function parseAddressIncidentPeople(
  arr,
  historyClickHandler,
  incidentId,
  handleAddPerson,
  handleOpenIncident,
  handleOpenPerson,
  userRoles
) {
  if (!arr || !Array.isArray(arr)) {
    console.error("Invalid input: arr should be an array");
    return null;
  }
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((incidentPerson) => {
      const { person, incident } = incidentPerson || {};
      const { personalAttribute, id: personId } = person || {};
      const { dob, phone } = personalAttribute || "";
      const { homeAddress } = personalAttribute || {};
      const name = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(person) }}
          data-cy={"tablecell-person-name-link-" + person?.id}
          onClick={() => {
            handleOpenPerson(person?.id, true);
          }}
        >
          {formatNameFromPersonObj(person)}
        </StyledTableLinkButton>
      );
      const incidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={handleOpenIncident}
          incident={incident}
          userRoles={userRoles}
        />
      );

      const dobString =
        moment
          .utc(dob, "YYYY-MM-DD HH:mm:ss UTC")
          .local()
          .format("MM/DD/YYYY") || "";
      const addressString = homeAddress?.name || "";

      const historyButton = (
        <button
          style={{
            backgroundColor: "transparent",
            color: "#6096d1",
            fontWeight: "bold",
            fontSize: "1rem",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
            display: "inline",
            margin: "0",
            padding: "0",
            "&:hover": {
              textDecoration: "none",
            },
            "&:focus": {
              textDecoration: "none",
            },
          }}
          onClick={() => {
            historyClickHandler(person);
          }}
        >
          Show History
        </button>
      );

      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-add-person-to-incident" + person?.id}
          onClick={() => handleAddPerson(person, incidentId)}
        >
          Add
        </button>
      ) : null;

      tempRows.push(
        createAddressIncidentPeopleData(
          incidentNumber,
          name,
          addressString,
          dobString,
          phone,
          historyButton,
          addButton,
          personId
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createAddressIncidentPeopleData(
  incidentNumber,
  name,
  address,
  dob,
  phone,
  history,
  addButton,
  personId
) {
  return {
    incidentNumber,
    name,
    address,
    dob,
    phone,
    history,
    addButton,
    personId,
  };
}

// ********************************************************************************************** //
